import React, { useState, useEffect } from 'react';
import ig from 'instagram-scraping';

import './InstagramScrapper.css';

const InstagramScrapper = () => {

    const [igData, setIgData] = useState( null );

    useEffect(() => {
        ig.scrapeUserPage('motoslucho').then(result => {
            if (result.medias) setIgData(result.medias);
        });
    }, []);

    const igMedia = [];
    if(igData) {
        for (let index = 0; index < 6; index++) {
            igMedia.push(<div key={index} className="item" onClick={() => window.open('https://www.instagram.com/p/' + igData[index].shortcode, '_blank')}><img src={igData[index].thumbnail} alt="IG Item" /></div>);
        }
    }

    return (
        <section className="instagram-scrapper">
            <div className="container">
                <h2 style={{color: "#fff"}}>Siguenos en <a className="text-danger" href="https://instagram.com/motoslucho" target="_blank" rel="noopener noreferrer">Instagram</a></h2>
            </div>
            {
                igData ?
                    <div className="media-content">
                        {igMedia}
                    </div>
                : <p style={{textAlign: "center", color: "#fff"}}>Cargando...</p>
            }
        </section>
    )
}

export default InstagramScrapper;